import { render, staticRenderFns } from "./MoreSenses.vue?vue&type=template&id=1ae9ea71&scoped=true&"
import script from "./MoreSenses.vue?vue&type=script&lang=ts&"
export * from "./MoreSenses.vue?vue&type=script&lang=ts&"
import style0 from "./MoreSenses.vue?vue&type=style&index=0&id=1ae9ea71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9ea71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
